import styles from "./OrderSummaryModal.module.scss";
import orderImg from "../../../assets/order.png";

interface OrderSummaryModalProps {}

const OrderSummaryModal: React.FC<OrderSummaryModalProps> = () => {
  return (
    <div className={styles.root}>
      <img src={orderImg} alt="order" />
    </div>
  );
};

export default OrderSummaryModal;
